// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I00P","badges":"styles_badges__2A14I"};